import React from 'react';
import { withTabItems } from '../common/RoutableTabContainer';
import CashTransferMatchPane from './CashTransferMatchPane';
import OffMarketTransferList from './OffMarketTransferList';
import withSuspense from '../common/table/Suspention';
import CSIcon from '../activityCS/CSIcon';
import IBICon from '../activityIB/IBIcon';
import IBBrokerCashTransferList from './IBBrokerCashTransferList';
import BankIcon from '../../icons/Bank';


const TransferList = withSuspense(
  React.lazy(() => (process.env.DEPLOYMENT_CODE === 'UK'
    ? import('./uk/TransfersList')
    : import('./PositionTransferMatchPane'))),
);

const depCodeCashTabs = [];
if (process.env.DEPLOYMENT_CODE === 'UK') {
  const LBGBrokerCashTransferList = withSuspense(
    React.lazy(() => import('./uk/BankBrokerCashTransferList')),
  );
  const CSMoneyStatementList = withSuspense(
    React.lazy(() => import('../activityCS/CSMoneyStatementList')),
  );
  const CSPreAdvisedFileList = withSuspense(
    React.lazy(() => import('./uk/CSPreAdviseFileList')),
  );

  depCodeCashTabs.push({
    label: 'Cash',
    icon: BankIcon,
    titleLabel: 'Cash (Bank)',
    url: 'bank-cash',
    comp: CashTransferMatchPane,
    propCopyFn: props => ({
      ...props,
      custodian: 'BK',
      contraCustodian: 'IB',
      contraOnly: false,
      contraPartyFilter: true,
      brokerCashTransactionList: LBGBrokerCashTransferList,
    }),
  });

  depCodeCashTabs.push({
    label: 'Cash',
    icon: CSIcon,
    url: 'cs-cash',
    titleLabel: 'Cash (CS)',
    comp: CashTransferMatchPane,
    propCopyFn: props => ({
      ...props,
      custodian: 'CS',
      contraCustodian: 'IB',
      contraOnly: false,
      brokerCashTransactionList: CSMoneyStatementList,
    }),
  });

  depCodeCashTabs.push({
    label: 'Cash Pre Advise',
    url: 'cs-pre-advise',
    comp: CSPreAdvisedFileList,
    tooltip: 'MT210: Pre-Advised cash transfer file send to Clearstream, to notify incoming cash transfers',
    icon: CSIcon,
  });
}

const tabEntries = [
  {
    label: 'Cash',
    url: 'ib-cash',
    icon: IBICon,
    comp: CashTransferMatchPane,
    titleLabel: 'Cash (IB)',
    propCopyFn: props => ({
      ...props,
      custodian: 'IB',
      contraCustodian: 'BK',
      contraOnly: true,
      brokerCashTransactionList: IBBrokerCashTransferList,
    }),
  },
  ...depCodeCashTabs,
  {
    label: 'Position',
    url: 'position',
    comp: TransferList,
  },
  {
    label: 'Off Market',
    url: 'off-market',
    comp: OffMarketTransferList,
  },
];


export default withTabItems(tabEntries, () => 'Transfers \u2022 ');
